import { render, staticRenderFns } from "./PokemonManager.vue?vue&type=template&id=157eb7ba&scoped=true"
import script from "./PokemonManager.vue?vue&type=script&lang=js"
export * from "./PokemonManager.vue?vue&type=script&lang=js"
import style0 from "./PokemonManager.vue?vue&type=style&index=0&id=157eb7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157eb7ba",
  null
  
)

export default component.exports